
import { useQuery } from "@tanstack/react-query";
import { feedService } from "@/services/feedService";
import PostCard from "@/components/profile/PostCard";
import CommentActivityCard from "@/components/profile/CommentActivityCard";
import PodcastCommentActivityCard from "@/components/profile/PodcastCommentActivityCard";
import { Skeleton } from "@/components/ui/skeleton";
import { MessageSquare } from "lucide-react";
import T from "@/i18n/T";

const ForYouFeed = () => {
  const { data: activities, isLoading } = useQuery({
    queryKey: ['for-you-feed'],
    queryFn: () => feedService.getForYouFeed(),
  });

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  }

  if (!activities || activities.length === 0) {
    return (
      <div className="text-center py-12">
        <MessageSquare className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold"><T k="auto.the-feed-is-quiet-3196" /></h3>
        <p className="text-muted-foreground"><T k="auto.there-are-no-posts-to-show-right-now-che-50f0" /></p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {activities.map((activity: any) => {
        if (activity.type === 'post') {
          return <PostCard key={`post-${activity.id}`} post={activity} />;
        } else if (activity.type === 'podcast_comment') {
          return <PodcastCommentActivityCard key={`podcast-comment-${activity.id}`} comment={activity} />;
        } else {
          return <CommentActivityCard key={`comment-${activity.id}`} comment={activity} />;
        }
      })}
    </div>
  );
};

export default ForYouFeed;
